export default {

    'USD': '$',
    'EUR': '€',
    'CAD': 'CAD',
    'GBP': '£',
    'CNY': '¥',
    'AUD': 'AUD'

};



// WEBPACK FOOTER //
// ./src/lang/currency.js